export default "__VITE_ASSET__Dopuhqid__"